import IframeActivity from "./IframeActivity";

export default function TennisInTheWind() {
    return (
        <IframeActivity
            src="/activities/tennis-in-the-wind/index.html"
            title="Tennis in the Wind"
        />
    );
}